import React from 'react';
import { Header, SideBar, Footer, Notification } from 'modules/core/components';
import { ContainerFluid, PageContainer, PageContent } from 'common/styles';
import { UnlockInventoryDialog } from 'components/Modals/UnlockInventoryDialog/UnlockInventoryDialog';
import { SelectLenderDialog } from 'components/Modals/SelectLenderDialog';
import { AchievementBanner } from 'components/Gamification/AchievementBanner';
import { useModalState } from 'modules/core/hooks';
import { MODAL_DIALOG_ID } from 'modules/core/constants';
import { useDealerSsoLenderSelection } from 'hooks/useDealerSsoLenderSelection';

interface IMainLayout {
  children: React.ReactNode;
  isSinglePage: boolean;
}

export const MainLayout: React.FC<IMainLayout> = ({ children, isSinglePage }) => {
  const { isModalDialogActive, handleCloseDialog } = useModalState([MODAL_DIALOG_ID.UNLOCK_INVENTORY]);
  const { showModal, selectableLenders, secondaryLinks, handleSelect } = useDealerSsoLenderSelection();

  return (
    <ContainerFluid fluid>
      <Notification />
      <AchievementBanner />
      <Header />
      <PageContainer>
        <SideBar />
        <PageContent $isSinglePage={isSinglePage} fluid>
          {children}
        </PageContent>
      </PageContainer>
      <Footer />
      <UnlockInventoryDialog show={isModalDialogActive} onHide={handleCloseDialog()} />
      <SelectLenderDialog
        show={showModal}
        lenders={selectableLenders}
        secondaryLinks={secondaryLinks}
        onSelect={handleSelect}
      />
    </ContainerFluid>
  );
};
